import Admin from './Admin'
const actions = {
  ...Admin,
}

export default actions
